import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";

var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Pagination);

    this.pageNo = 1;
    this.pageSize = 20;
    this.total = 0; // 根据 options 初始化参数

    var keys = Object.keys(options);
    keys.forEach(function (key) {
      _this[key] = options[key];
    });
  }

  _createClass(Pagination, [{
    key: "setPageNo",
    value: function setPageNo() {
      var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pageNo;
      this.pageNo = pageNo;
    }
  }, {
    key: "setPageSize",
    value: function setPageSize() {
      var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pageSize;
      this.pageSize = pageSize;
    }
  }, {
    key: "setTotal",
    value: function setTotal() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.total;
      this.total = total;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.pageNo = 1;
      this.pageSize = 20;
    }
  }]);

  return Pagination;
}();

export default Pagination;